import { useEffect, useState } from 'react';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollToCTA = () => {
    document.getElementById('cta-final')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#0A0A0A]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20background%20with%20vibrant%20mint%20green%20glowing%20geometric%20shapes%2C%20dynamic%20diagonal%20lines%2C%20modern%20tech%20startup%20visual%20identity%2C%20deep%20black%20with%20cool%20green%20and%20teal%20light%20streaks%2C%20ultra%20high%20contrast%2C%20cinematic%20wide%20angle%20composition%2C%208k%20quality%2C%20professional%20digital%20art&width=1440&height=900&seq=hero-bg-green-2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
      </div>

      {/* Decorative glow */}
      <div className="absolute top-1/3 right-1/4 w-96 h-96 rounded-full bg-[#6ECFA0]/10 blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/3 right-10 w-64 h-64 rounded-full bg-[#00C97B]/8 blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-24 pb-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className={`inline-flex items-center gap-2 bg-[#6ECFA0]/15 border border-[#6ECFA0]/30 text-[#6ECFA0] text-sm font-semibold px-4 py-2 rounded-full mb-8 transition-all duration-700 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <span className="w-2 h-2 bg-[#6ECFA0] rounded-full animate-pulse inline-block" />
            Force commerciale externalisée
          </div>

          {/* Headline */}
          <h1
            className={`text-6xl lg:text-7xl xl:text-8xl font-black leading-none mb-6 transition-all duration-700 delay-100 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <span className="text-white">Boostez vos</span>
            <br />
            <span className="text-[#6ECFA0]">ventes</span>
            <br />
            <span className="text-white">sans recruter</span>
          </h1>

          {/* Subheadline */}
          <p
            className={`text-lg lg:text-xl text-white/70 max-w-xl leading-relaxed mb-10 transition-all duration-700 delay-200 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            Télévendeurs et business developers opérationnels sous&nbsp;48h — sans recrutement,
            sans charges, sans prise de tête. Vos résultats, notre mission.
          </p>

          {/* CTAs */}
          <div
            className={`flex flex-col sm:flex-row items-start sm:items-center gap-4 transition-all duration-700 delay-300 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <button
              onClick={scrollToCTA}
              className="group flex items-center gap-3 bg-[#6ECFA0] hover:bg-[#8DDAB5] text-black font-bold text-base px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Demander un devis gratuit
              <span className="w-8 h-8 flex items-center justify-center bg-black/20 rounded-full group-hover:translate-x-1 transition-transform duration-200">
                <i className="ri-arrow-right-line text-black" />
              </span>
            </button>
            <button
              onClick={() => document.getElementById('solution')?.scrollIntoView({ behavior: 'smooth' })}
              className="flex items-center gap-2 text-white/70 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg" />
              Découvrir l&apos;offre
            </button>
          </div>

          {/* Stats */}
          <div
            className={`flex flex-wrap gap-8 mt-16 pt-8 border-t border-white/10 transition-all duration-700 delay-500 ${
              loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            {[
              { value: '+150', label: 'Clients actifs' },
              { value: '48h', label: 'Délai de démarrage' },
              { value: '0€', label: 'Charge patronale' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="text-3xl font-black text-[#6ECFA0]">{stat.value}</span>
                <span className="text-sm text-white/50 mt-1">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/30 text-xs">
        <span>Scroll</span>
        <i className="ri-arrow-down-line animate-bounce" />
      </div>
    </section>
  );
}
